import * as angular from 'angular';
import {IController} from "angular";
import {$accountsFactory} from "../../$accounts.factory";

export class AccountDisplayValueCtrl implements IController {
  id: any;

  private accountsRef: any;
  private selectedAccount: any;

  /* @ngInject */
  constructor(private $accounts: $accountsFactory, private $log) {
    this.accountsRef = this.$accounts();
  }

  $onInit() {
    this.setItem(this.id);
  }

  $onChanges(changes) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.setItem(this.id);
    }
  }

  private setItem(id) {
    if (id) {
      this.accountsRef.$asyncValues([id])
        .then((accounts) => {
          this.selectedAccount = accounts[0];
        })
        .catch((error) => {
          this.$log.error('Failed to get accounts', error);
        })
    } else {
      this.selectedAccount = undefined;
    }
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountDisplayValue', {
    bindings: {
      id: '<',
      onChange: '&'
    },
    template: require('./account-display-value.html').default,
    controller: AccountDisplayValueCtrl
  });
